import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Loader2, RefreshCw, ExternalLink, Monitor, Smartphone, Eye } from "lucide-react";

export const VendrePreview = ({ refreshKey }) => {
  const [link, setLink] = useState(null);
  const [failed, setFailed] = useState(false);
  const [device, setDevice] = useState("desktop");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    api.get("/vendor/shop/preview").then(({ data }) => setLink(data)).catch(() => setFailed(true));
  }, []);

  if (failed) return null;
  if (!link) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white h-64 flex items-center justify-center" data-testid="vendre-preview-loading">
        <Loader2 className="h-5 w-5 animate-spin text-violet-600" />
      </div>
    );
  }

  const url = `/p/${link.slug}?pt=${link.preview_token}`;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden" data-testid="vendre-preview">
      <div className="flex items-center gap-2 px-4 h-12 border-b border-slate-100 bg-slate-50/60">
        <Eye className="h-4 w-4 text-violet-600 shrink-0" />
        <div className="text-xs font-bold text-slate-800">Aperçu en direct</div>
        {!link.published && (
          <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 text-[10px] font-bold" data-testid="vendre-preview-unpublished">Non publiée — visible par vous seul</span>
        )}
        <div className="ml-auto flex items-center gap-1">
          <button
            onClick={() => setDevice("desktop")}
            className={`h-8 w-8 rounded-lg flex items-center justify-center transition-colors ${device === "desktop" ? "bg-slate-900 text-white" : "text-slate-400 hover:bg-slate-100"}`}
            title="Vue ordinateur" data-testid="vendre-preview-desktop"
          >
            <Monitor className="h-3.5 w-3.5" />
          </button>
          <button
            onClick={() => setDevice("mobile")}
            className={`h-8 w-8 rounded-lg flex items-center justify-center transition-colors ${device === "mobile" ? "bg-slate-900 text-white" : "text-slate-400 hover:bg-slate-100"}`}
            title="Vue mobile" data-testid="vendre-preview-mobile"
          >
            <Smartphone className="h-3.5 w-3.5" />
          </button>
          <div className="w-px h-5 bg-slate-200 mx-1" />
          <button
            onClick={() => setReload((r) => r + 1)}
            className="h-8 w-8 rounded-lg text-slate-400 hover:bg-slate-100 flex items-center justify-center transition-colors"
            title="Actualiser l'aperçu" data-testid="vendre-preview-refresh"
          >
            <RefreshCw className="h-3.5 w-3.5" />
          </button>
          <a
            href={url} target="_blank" rel="noreferrer"
            className="h-8 w-8 rounded-lg text-slate-400 hover:bg-slate-100 flex items-center justify-center transition-colors"
            title="Ouvrir dans un nouvel onglet" data-testid="vendre-preview-open"
          >
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>
      </div>
      <div className={`bg-slate-100 ${device === "mobile" ? "flex justify-center py-4" : ""}`}>
        <iframe
          key={`${refreshKey}-${reload}`}
          src={url}
          title="Aperçu de votre page de réservation"
          className={device === "mobile" ? "w-[390px] h-[600px] rounded-xl border border-slate-300 bg-white shadow-lg" : "w-full h-[600px] border-0 bg-white"}
          data-testid="vendre-preview-iframe"
        />
      </div>
    </div>
  );
};
